<template>
  <div>
    <Layout/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarProcedimiento" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarProcedimiento" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditProcedimiento" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAtencionDet</th>
          <th scope="col">IdAtencion</th>
          <th scope="col">IdElemento</th>
          <th scope="col">Cantidad</th>
          <th scope="col">PrecioUnitario</th>
          <th scope="col">Estado</th>
          <th scope="col">ObsAtencion</th>
          <th scope="col">FechaAtencion</th>
          <th scope="col">Elemento</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="atenciondet in datosPaginados" :key="atenciondet.idprocedimiento">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(atenciondet.idProcedimiento)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(atenciondet.idProcedimiento)" title="Editar">edit_square</i></td>
          <td>{{atenciondet.idAtencionDet}}</td>
          <td>{{atenciondet.idAtencion}}</td>
          <td>{{atenciondet.idElemento}}</td>
          <td>{{atenciondet.cantidad}}</td>
          <td>{{atenciondet.precioUnitario}}</td>
          <td>{{atenciondet.estado}}</td>
          <td>{{atenciondet.obsAtencion}}</td>
          <td>{{getFormattedDate(atenciondet.fechaAtencion, 'DD/MM/YYYY')}}</td>
          <td>{{atenciondet.elemento}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteProcedimiento(atenciondet.idProcedimiento)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencionDet" class="form-label">IdAtencionDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencionDet" name="idAtencionDet" v-model="datoAtencionDet.idAtencionDet" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencionDet.idAtencion"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="atencion" name="atencion" v-model="datoAtencionDet.atencion" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalAtencionLOV"
                      title="Buscar ">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idElemento" name="idElemento" v-model="datoAtencionDet.idElemento"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="elemento" name="elemento" v-model="datoAtencionDet.elemento" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalElementoLOV"
                      title="Buscar ">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cantidad" class="form-label">Cantidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="cantidad" name="cantidad" v-model="datoAtencionDet.cantidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="precioUnitario" class="form-label">PrecioUnitario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="precioUnitario" name="precioUnitario" v-model="datoAtencionDet.precioUnitario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtencionDet" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtencionDet" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: AtencionDet -->
    <AtencionDetLOVdet @DatosAtencionDet="GetDataAtencionDetLOVdet($event)"/>
<!-- Lista de Valores: Atencion -->
    <AtencionLOVdet @DatosAtencion="GetDataAtencionLOVdet($event)"/>
<!-- Lista de Valores: Elemento -->
    <ElementoLOVdet @DatosElemento="GetDataElementoLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import AtencionDetLOVdet from '../../components/lovs/AtencionDetLOV.vue'
import AtencionLOVdet from '../../components/lovs/AtencionLOV.vue'
import ElementoLOVdet from '../../components/lovs/AtencionLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, AtencionDetLOVdet
, AtencionLOVdet
, ElementoLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      procedimientos : [],
      datoProcedimiento : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idProcedimiento: '',
// Variables master
// Variables details
      atenciondets : [],
      datoAtencionDet : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idProcedimiento = this.$route.params.p_idprocedimiento
    this.abrirEditar(this.p_idProcedimiento)
    this.getAtencionDets()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      return 1;
    },
    async guardarProcedimiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/procedimientos', this.datoProcedimiento)
          swal("Correcto!", "Procedimiento creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditProcedimiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/procedimientos', this.datoProcedimiento)
          swal("Correcto!", "Procedimiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoProcedimiento={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idProcedimiento){
      this.modalWindow = true
      if(idProcedimiento != null){    
           api.get('/vwprocedimientos/'+idProcedimiento).then(resp=>{
          this.datoProcedimiento = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarProcedimiento(){
      this.$router.push('/Procedimiento')
    },
// Procedimientos master
// Procedimientos detalle
    async getAtencionDets() {
      const resp = await api.get('/atenciondets')
      this.atenciondets = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.atenciondets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwatenciondets/nombre/'+this.nombreBusqueda).then(response=>{
          this.atenciondets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.atenciondets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwatenciondets').then(response=>{
      this.atenciondets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.atenciondets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      return 1;
    },
    async guardarAtencionDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atenciondets', this.datoAtencionDet)
          this.getAtencionDets();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AtencionDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtencionDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atenciondets', this.datoAtencionDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AtencionDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAtencionDet={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAtencionDet){
      this.modalWindow = true
      if(idAtencionDet != null){    
           api.get('/vwatenciondets/'+idAtencionDet).then(resp=>{
          this.datoAtencionDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAtencionDet){
      this.modalWindow = true
      if(idAtencionDet != null){
        this.$router.push('/atenciondetmd/'+idAtencionDet)
      }
    },
    async deleteAtencionDet (idAtencionDet) {
      try{
        await api.delete('/atenciondets/'+idAtencionDet)
          this.getAtencionDets()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataAtencionDetLOVdet(data) {
      this.datoAtencionDet.idAtencionDet = data.idAtencionDet;
      this.datoAtencionDet.atencionDet = data.nombre;
    },
//    Lista de Valores
    GetDataAtencionLOVdet(data) {
      this.datoAtencionDet.idAtencion = data.idAtencion;
      this.datoAtencionDet.atencion = data.nombre;
    },
//    Lista de Valores
    GetDataElementoLOVdet(data) {
      this.datoAtencionDet.idElemento = data.idElemento;
      this.datoAtencionDet.elemento = data.nombre;
    },
// Listas de valores details
  },
}
</script>
